import {ProjectTimeTimelineDayContent} from "../timelineTypes";

/**
 * Component to display validation results in a project time timeline day.
 * This component is used inside <code>ProjectTimeTimelineDay</code> to render validation results for a specific day. If available, this component is appended to the day container.
 * For an overview of the timeline architecture, have a look into the UML diagram "timeline_web_components.png"
 */
export class ProjectTimeTimelineDayValidations extends HTMLElement {
	private _timelineDay: ProjectTimeTimelineDayContent;

	set timelineDay(value: ProjectTimeTimelineDayContent) {
		this._timelineDay = value;
	}

	/**
	 * Main entry point to render the validation results.
	 */
	public connectedCallback(): void {
		// timeline day and validations are required to render this component
		if (!this._timelineDay || !this._timelineDay.validationResults.length) {
			return;
		}

		const validations = this._timelineDay.validationResults.map(validation => {
			const tr = document.createElement("tr");
			tr.innerHTML = `
					<td class="pb-5"><i class="fa fa-validation-severity-${validation.severity} position-left" title="${messages["recordingValidation.severity." + validation.severity]}"></i></td>
					<td class="pb-5">${messages.withArguments(validation.messageCode, ...validation.messageArguments)}</td>
					`;
			return tr;
		});

		const container = document.createElement("div");
		container.append(...validations);
		this.append(container);
	}
}
